<template>
<div class="main">
    <div class="am-main-box am-main-top-box">
        <div class="am-main-box-title am-main-top-box-titlesystem-font">Commission Filings Merge</div>
        <router-link class="icons" :to="{name: 'commissions.reconcile.main', query: {status: 0}}">
            <svg-icon class="am-glyphicon-medium am-glyphicon-white" icon="back" title="Back"></svg-icon>
        </router-link>
    </div>
    <div class="content system-font"><span class="center">These files will be deleted</span>
        <p class="text-center red bold" v-for="file in fromFiles">{{file.company}} <br/> ${{ file.total | number }} - {{ file.created }}, {{ file.start }}, {{ file.end }}, {{ file.deposited }} {{ file.creator }}</p><span class="center">And all activity will be moved to</span>
        <p class="text-center green bold"
            v-for="file in toFiles">{{file.company}} <br/> ${{ file.total | number }} - {{ file.created }}, {{ file.start }}, {{ file.end }}, {{ file.deposited }} {{ file.creator }}</p><br/><span class="center red">Are you SURE you want to merge these files?</span><span class="center">To continue merging hit &quot;Save&quot;, else press the back arrow button</span></div>
    <div
        class="am-main-box am-main-bottom-box">
        <a class="save-button" href="" @click.prevent="mergeFiles">
            <img src="@/assets/save.png">
        </a>
</div>
</div>
</template>

<script>
import makesAjaxRequests from '@/mixins/makesAjaxRequests'

export default {
  name: 'MergeConfirm',

  mixins: [makesAjaxRequests],

  props: {
    fromIds: {
      type: Array
    },

    toIds: {
      type: Array
    }
  },

  data () {
    return {
      fromFiles: [],
      toFiles: []
    }
  },

  computed: {
  },

  methods: {
    async fetchFiles (ids, type) {
      this.ajaxCall(this.$http.post('commission/file/fetch', { ids }).then(resp => {
        if (type === 'from') {
          this.fromFiles = resp.data.data.map(file => {
            return {
              ...file
            }
          })
        } else {
          this.toFiles = resp.data.data.map(file => {
            return {
              ...file
            }
          })
        }
      }))
    },

    mergeFiles () {
      var fromIds = this.fromIds
      var toIds = this.toIds
      var ids = toIds.concat(fromIds)
      this.ajaxCall(this.$http.post('commission/file/merge', { ids }).then(resp => {
        this.$router.push({
          name: 'commissions.reconcile.main',
          query: { status: 0 }
        })
      }))
    }
  },

  beforeMount () {
    this.fetchFiles(this.fromIds, 'from')
    this.fetchFiles(this.toIds, 'to')
  }
}
</script>

<style lang="sass" scoped>
  .main
    border: 1px solid #AAAAAA
    margin: 12px 0 30px 12px
    background-color: #F6F6F6
    min-width: 450px
    float: left
    border-radius: 6px

  .am-main-box
    background: #2A95CC repeat-x
    height: 37px
    font-size: 11px
    font-weight: bold

  .am-main-box-title
    color: #FFFFFF
    padding: 10px 10px 0 10px
    float: left

  .icons
    color: #FFFF00
    padding: 8px 3px 0 3px
    float: right

  .content
    padding: 16px 16px 26px 16px

  .save-button
      color: #FFFF00
      float: left
      padding-top: 5px
      padding-left: 8px

  .system-font
    font-family: Arial, Helvetica, sans-serif

  .center
    display: table
    margin: 0 auto

  .red
    color: red

  .green
    color: green

  .bold
    font-weight: bold
</style>
